/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as commonConstants from '../../../../common/constants';
import * as studioConstants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';

export default class GetCdnTokenService extends BaseService {
  constructor() {
    super(studioConstants.GET_CDN_TOKEN, 'getCdnTokenStatus');
  }

  async handleEvent() {
    const headers = {
      'Content-Type': 'application/json'
    };

    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get(`/${commonConstants.GET_CDN_TOKEN_URL}`, {
        headers: enhancedHeaders
      });
    }
    return this.getClient('aiadmin').get(`/${commonConstants.GET_CDN_TOKEN_URL}`, { headers });
  }

  handleResponse(response, event) {
    const requestId = event?.payload?.requestId;
    const { data } = response;
    if (data && data.data) {
      Framework.getEventManager().publish(studioConstants.GET_CDN_TOKEN_SUCCESS, {
        data,
        requestId
      });
    } else {
      Framework.getEventManager().publish(studioConstants.GET_CDN_TOKEN_ERROR, {
        message: data?.message || 'Error fetching cdn token',
        requestId
      });
    }
  }

  handleError(error, event) {
    const requestId = event?.payload?.requestId;
    Framework.getEventManager().publish(studioConstants.GET_CDN_TOKEN_ERROR, {
      message: error?.message || 'Error fetching cdn token',
      requestId
    });
  }
}
